import React from "react";
import SidePanel from "..";
import t from "../../../../../../i18n";
import CreateFormulaQuantity, {
  type CreateFormulaQuantityHandle,
} from "../../CreateFormulaQuantity";

interface Props {
  projectId: string;
  timezone: string;
  isFolded: boolean;
  closePanel: () => void;
}

const CreateFormulaQuantitySidePanel = ({ projectId, timezone, isFolded, closePanel }: Props) => {
  const createQuantityRef = React.useRef<CreateFormulaQuantityHandle>(null);
  const [quantityName, setQuantityName] = React.useState<string | null>(null);
  const resetFormAndClosePanel = () => {
    createQuantityRef.current?.resetForm();
    setQuantityName(null);
    closePanel();
  };

  return (
    <SidePanel
      title={t("project.settings.quantity.side_panel.create.title")}
      subtitle={quantityName}
      closeHandler={resetFormAndClosePanel}
      isFolded={isFolded}
      hasFormula
    >
      {sidePanelView => (
        <CreateFormulaQuantity
          timezone={timezone}
          ref={createQuantityRef}
          projectId={projectId}
          closePanel={resetFormAndClosePanel}
          view={sidePanelView}
          onNameChange={setQuantityName}
        />
      )}
    </SidePanel>
  );
};

export default CreateFormulaQuantitySidePanel;
